import React, { useState } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import {
  createNewAdApi,
  fetchAdApis,
  updateAdApi,
} from "../../services/axios/apiManager";
import { AdApisValidationSchema } from "./adsApiValidations";
import { Formik } from "formik";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { handleErrors } from "../../services/dataManager";
import LoadingSpinner from "../../Components/spinner";
const AddAdApiModal = ({
  selectedAdApi,
  setSelectedAdApi,
  showModal,
  handleHideModal,
  setAdsApis,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const handleCreateOrEdit = async (data) => {
    if (selectedAdApi?.id) {
      const updateResponse = await updateAdApi({
        id: selectedAdApi.id,
        ...data,
      });

      if (updateResponse?.data?.success) {
        const response = await fetchAdApis();
        if (response?.data?.data) {
          setAdsApis(response.data.data);
        }
        toast.success("Ad Api has been updated!", { duration: 2000 });
        handleHideModal();
      } else {
        handleErrors(updateResponse, navigate, "Update Ad API:");
      }
    } else {
      const addResponse = await createNewAdApi(data);
      if (addResponse?.data?.success) {
        const response = await fetchAdApis();
        if (response?.data?.data) {
          setAdsApis(response.data.data);
        }
        toast.success("Ad Api has been Added!", { duration: 2000 });
        handleHideModal();
      } else {
        handleErrors(addResponse, navigate, "Ad API:");
      }
    }
  };

  return (
    <Modal
      show={showModal}
      onHide={handleHideModal}
      centered
      backdrop="static"
      className="text-light"
      size="lg"
    >
      <Modal.Header closeButton className="bg-dark text-light border-0">
        <Modal.Title className="text-light">
          {selectedAdApi?.id ? "Edit Ad API" : "Add New Ad API"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark text-light">
        <Formik
          initialValues={{
            name: selectedAdApi?.name || "",
            email: selectedAdApi?.credentials?.email || "",
            user_name: selectedAdApi?.credentials?.user_name || null,
            password: selectedAdApi?.credentials?.password || null,
            key: selectedAdApi?.credentials?.key || null,
            using_social: selectedAdApi?.using_social || 0,
            status: selectedAdApi?.status || 1,
          }}
          validationSchema={AdApisValidationSchema}
          onSubmit={async (values) => {
            try {
              setLoading(true);
              if (loading) {
                return;
              }
              const data = {
                name: values.name,
                status: values.status,
                using_social: values.using_social,
                credentials: {
                  email: values.email,
                  user_name: values.user_name,
                  password: values.password,
                  key: values.key,
                },
              };
              await handleCreateOrEdit(data);
            } catch (error) {
              console.log("Error upon Change Password", error);
            } finally {
              setLoading(false);
            }
          }}
        >
          {({
            handleChange,
            setFieldValue,
            handleSubmit,
            values,
            errors,
            touched,
          }) => (
            <div>
              <Form.Group className="mb-3">
                <Form.Label>Name*</Form.Label>
                <Form.Control
                  type="text"
                  id="name"
                  value={values.name}
                  onChange={handleChange("name")}
                  placeholder="Enter name"
                  className="bg-dark text-light border-light"
                />
                {errors?.name && touched?.name ? (
                  <span className="text-danger">{errors?.name}</span>
                ) : null}
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Email*</Form.Label>
                <Form.Control
                  type="text"
                  id="email"
                  value={values.email}
                  onChange={handleChange("email")}
                  placeholder="Enter Email"
                  className="bg-dark text-light border-light"
                />
                {errors?.email && touched?.email ? (
                  <span className="text-danger">{errors?.email}</span>
                ) : null}
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Username</Form.Label>
                <Form.Control
                  type="text"
                  id="username"
                  value={values.user_name}
                  onChange={handleChange("user_name")}
                  placeholder="Enter username"
                  className="bg-dark text-light border-light"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>
                  Password (current password can be viewed in details)
                </Form.Label>
                <Form.Control
                  type="password"
                  id="password"
                  value={values.password}
                  onChange={handleChange("password")}
                  placeholder="Enter password"
                  className="bg-dark text-light border-light"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Key</Form.Label>
                <Form.Control
                  type="text"
                  id="key"
                  value={values.key}
                  onChange={handleChange("key")}
                  placeholder="Enter key"
                  className="bg-dark text-light border-light"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>
                  Log-In via social (eg. Google, Outlook, etc)
                </Form.Label>
                <Form.Control
                  as="select"
                  id="using_social"
                  value={selectedAdApi.using_social || 0}
                    data-testid="using_social_input"
                  onChange={(e) => {
                    setFieldValue("using_social", e.target.value);
                    setSelectedAdApi((prev) => ({
                      ...prev,
                      using_social: e.target.value,
                    }));
                  }}
                  className="bg-dark text-light border-light"
                >
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </Form.Control>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <Form.Control
                  as="select"
                  id="status"
                  value={selectedAdApi.status || 0}
                  data-testid="status_input"
                  onChange={(e) => {
                    setFieldValue("status", e.target.value);
                    setSelectedAdApi((prev) => ({
                      ...prev,
                      status: e.target.value,
                    }));
                  }}
                  className="bg-dark text-light border-light"
                >
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </Form.Control>
              </Form.Group>
              <div class="container-fluid">
                <div class="d-flex justify-content-end">
                  {loading && (
                    <div className="mt-4 mx-2">
                      <LoadingSpinner size={"lg"} />
                    </div>
                  )}
                  <Button
                    variant="success"
                    className="mt-3"
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    Save
                  </Button>
                </div>
              </div>
            </div>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default AddAdApiModal;
